import { useConfigurationStore } from '../Store/storeConfiguration';

export function saveProject() {
    function download(content, fileName, contentType) {
        const a = document.createElement('a');
        const file = new Blob([ content ], { type: contentType });
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    }
    download(JSON.stringify(useConfigurationStore().$state), 'data.json', 'text/plain');
}
